function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import EdenImage from "@churchofjesuschrist/eden-image";
import { spacing64 } from "@churchofjesuschrist/eden-style-constants";
const GradientStyled = styled.div.withConfig({
  componentId: "sc-1mbwfdm-0"
})(["position:absolute;width:100%;height:", ";bottom:0;background:linear-gradient( to bottom,hsla(198,9.8%,20%,0) 0%,hsla(198,9.8%,20%,0.008) 7.2%,hsla(198,9.8%,20%,0.032) 14.5%,hsla(198,9.8%,20%,0.069) 21.8%,hsla(198,9.8%,20%,0.118) 29.1%,hsla(198,9.8%,20%,0.177) 36.4%,hsla(198,9.8%,20%,0.244) 43.6%,hsla(198,9.8%,20%,0.317) 50.6%,hsla(198,9.8%,20%,0.395) 57.6%,hsla(198,9.8%,20%,0.474) 64.4%,hsla(198,9.8%,20%,0.555) 71%,hsla(198,9.8%,20%,0.634) 77.3%,hsla(198,9.8%,20%,0.71) 83.5%,hsla(198,9.8%,20%,0.781) 89.3%,hsla(198,9.8%,20%,0.845) 94.8%,hsla(198,9.8%,20%,0.9) 100% );"], spacing64);
const ImageStyled = styled(_ref => {
  let { ...props
  } = _ref;
  delete props.cover;
  return /*#__PURE__*/React.createElement(EdenImage, props);
}).withConfig({
  componentId: "sc-1mbwfdm-1"
})(["display:block;width:100%;", ";"], _ref2 => {
  let {
    cover
  } = _ref2;
  return cover && css(["@supports (object-fit:cover){height:100%;object-fit:cover;}"]);
});

const Image = _ref3 => {
  let {
    src,
    alt,
    cover,
    showOverlay,
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement(Fragment, null, showOverlay ? /*#__PURE__*/React.createElement(GradientStyled, null) : null, /*#__PURE__*/React.createElement(ImageStyled, _extends({
    src,
    alt,
    cover
  }, props)));
};

Image.propTypes = {
  /** Determine if object-fit: cover should be applied */
  cover: PropTypes.bool,

  /** Image source */
  src: PropTypes.string,

  /** Alt text for image */
  alt: PropTypes.string,

  /** A bool to use gradient on an image */
  showOverlay: PropTypes.bool
};
export default Image;